<pux-translate tag="span" html="_LBL_HTML_REGISTRIERUNG_HEADER_"></pux-translate>